'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Job;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _MatchTooltip = require('shared/components/MatchTooltip');

var _MatchTooltip2 = _interopRequireDefault(_MatchTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getImage = function getImage(image) {
  if (image && image.url) {
    return _react2.default.createElement('img', { src: image.url, alt: image.title });
  }

  return null;
};

function Job(_ref) {
  var title = _ref.title,
      content = _ref.content,
      subsectors = _ref.subsectors,
      fullSlug = _ref.fullSlug,
      image = _ref.image,
      match = _ref.match;

  return _react2.default.createElement(
    'div',
    { className: 'job' },
    _react2.default.createElement(
      'div',
      { className: 'job-image' },
      getImage(image),
      _react2.default.createElement(_MatchTooltip2.default, {
        match: match,
        _class: 'c-tooltip up green-dark',
        matchMeComponent: function matchMeComponent() {
          return _react2.default.createElement(
            'div',
            { className: 'no-match' },
            _react2.default.createElement(
              'span',
              null,
              'Match'
            ),
            _react2.default.createElement(
              'em',
              null,
              'me'
            )
          );
        },
        matchComponent: function matchComponent(parsedMatch) {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'em',
              null,
              parsedMatch
            ),
            _react2.default.createElement(
              'span',
              null,
              'Match'
            )
          );
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'job-info' },
      _react2.default.createElement(
        'h3',
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { to: fullSlug },
          title
        )
      ),
      _react2.default.createElement('div', {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }),
      _react2.default.createElement(
        'p',
        null,
        'See Jobs in: ',
        subsectors.map(function (subsector, key) {
          return _react2.default.createElement(
            _reactRouter.Link,
            {
              key: key,
              to: '/subsector/' + ('' + subsector.slug)
            },
            subsector.title
          );
        })
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/AllJobs/Job.jsx
// module id = 1140
// module chunks = 0